(function () {
  const trackingFields = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content'
  ];

  const params = new URLSearchParams(window.location.search);

  trackingFields.forEach(function (field) {
    const value = params.get(field);

    if (value) {
      localStorage.setItem(field, value);
    }
  });

  if (!localStorage.getItem('landing_page_url')) {
    localStorage.setItem('landing_page_url', window.location.href);
  }

  function addTrackingFieldsToForms() {
    const values = {
      utm_source: localStorage.getItem('utm_source') || '',
      utm_medium: localStorage.getItem('utm_medium') || '',
      utm_campaign: localStorage.getItem('utm_campaign') || '',
      utm_content: localStorage.getItem('utm_content') || '',
      landing_page_url: localStorage.getItem('landing_page_url') || '',
      conversion_page_url: window.location.href
    };

    document.querySelectorAll('form').forEach(function (form) {
      Object.keys(values).forEach(function (field) {
        let input = form.querySelector('input[name="' + field + '"]');

        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = field;
          form.appendChild(input);
        }

        input.value = values[field];
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addTrackingFieldsToForms);
  } else {
    addTrackingFieldsToForms();
  }
})();